/** Soft opacity crossfade — feedback lines and content swaps without layout bounce. */
export const gentleCrossfade = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: { duration: 0.32, ease: [0.22, 1, 0.36, 1] },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.32, ease: [0.4, 0, 0.2, 1] },
  },
};

/** Shared entrance / exit for demo interactions — avoids blur/filter glitches. */
export const flyInSpring = {
  initial: { opacity: 0, scale: 0.88, y: 22, rotate: -2 },
  animate: {
    opacity: 1,
    scale: 1,
    y: 0,
    rotate: 0,
    transition: { type: 'spring', stiffness: 420, damping: 28 },
  },
  exit: {
    opacity: 0,
    scale: 0.94,
    y: -14,
    transition: { duration: 0.22, ease: [0.22, 1, 0.36, 1] },
  },
};

export const flyInFromRight = {
  initial: { opacity: 0, x: 28, scale: 0.92 },
  animate: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: { type: 'spring', stiffness: 400, damping: 26 },
  },
  exit: {
    opacity: 0,
    x: -20,
    scale: 0.96,
    transition: { duration: 0.2 },
  },
};

export const staggerFlyIn = (index) => ({
  initial: { opacity: 0, scale: 0.6, y: 16 },
  animate: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 450,
      damping: 24,
      delay: index * 0.035,
    },
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    y: -8,
    transition: { duration: 0.18 },
  },
});
